

export const onChnageMuroAplication=({commit},payload)=>{
    commit("setMuroAplication",payload)
}